import { api } from "@infrastructure/api";
const GLOBAL_CONTEXT = { orgContext: "global" };
export const notificationDeliveryOperationsRepository = {
    async list(params = {}) {
        const response = await api.get("/admin/notification-deliveries", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return (response.data ?? {
            items: [],
            pagination: { limit: params.limit ?? 25, offset: 0, total: 0, has_more: false },
        });
    },
    async health() {
        const response = await api.get("/admin/notification-deliveries/health", GLOBAL_CONTEXT);
        return response.data;
    },
    async retry(id, payload) {
        const response = await api.post(`/admin/notification-deliveries/${encodeURIComponent(id)}/retry`, payload, GLOBAL_CONTEXT);
        return response.data ?? {};
    },
    async runScheduler(limit = 100) {
        const response = await api.post("/admin/notification-deliveries/scheduler/run", { limit }, GLOBAL_CONTEXT);
        return response.data ?? {};
    },
};
export default notificationDeliveryOperationsRepository;
